import { Config } from "@/shared/config";

export default {
  employee: {
    userPoolId: Config.Cognito.UserPoolId,
    clientId: Config.Cognito.ClientId,
    identityPoolId: Config.Cognito.IdentityPoolId
  },
  employer: {
    userPoolId: Config.Cognito.UserPoolId,
    clientId: Config.Cognito.ClientId,
    identityPoolId: Config.Cognito.IdentityPoolId
  },
  admin: {
    userPoolId: Config.AdminCognito.UserPoolId,
    clientId: Config.AdminCognito.ClientId,
    identityPoolId: Config.AdminCognito.IdentityPoolId
  }
};
